import React from "react";
import TeamCategoryFormPage from "../components/team/TeamCategoryFormPage";

const TeamCategoryCreate = () => <TeamCategoryFormPage mode="create" />;

export default TeamCategoryCreate;
